module.exports = __webpack_public_path__ + "static/media/Navisworks Freedom.6c84b0ba.png";